export enum filterType {
  UserType = 'UserType',
  PlanName = 'PlanName',
  Status = 'Status',
}
export enum EnumStep {
  UploadFile = 'UploadFile',
  PortalManagement = 'PortalManagement',
}

export enum orderByType {
  UserType = 'UserType',
  AmountOfFunding = 'AmountOfFunding',
  Name = 'Name',
}
export enum PopUp {
  GeneralMessage = 'GeneralMessage',
  UpdateUser = 'UpdateUser',
}

export enum ErrorType {
  IsCellcomUser = 'IsCellcomUser',
  SapOrderAlreadyCreated = 'SapOrderAlreadyCreated',
  ProcessNotCompletedByUser = 'ProcessNotCompletedByUser',
}

export enum searchType {
  Phone = 0,
  Name = 1,
}

export const UserTableColumn = [
  {value: 'fullName', name: 'שם מנוי', enableFilter: true, className: 'fullNameCol', width: '160px'},
  {value: 'userId', name: 'מספר ת.ז', enableFilter: false, className: '', width: '100px'},
  {value: 'subscriberNumber', name: 'מספר נייד', enableFilter: false, className: '', width: '110px'},
  {value: 'amountOfFunding', name: 'סכום פיצול ', enableFilter: true, className: '', width: '120px'},
  {value: 'status', name: 'סטטוס בקשה', enableFilter: false, className: 'statusCol', width: '135px'},
  {value: 'userType', name: 'מדרג', enableFilter: true, className: '', width: '120px'},
  {value: 'planName', name: 'תוכנית', enableFilter: false, className: '', width: '120px'},
  {value: 'phoneModelName', name: 'סוג מכשיר', enableFilter: false, className: '', width: '200px'},
  {value: 'distributionCenter', name: 'איזור חלוקה', enableFilter: false, className: '', width: '180px'},
  {value: 'actionType', name: 'פעולה', enableFilter: false, className: '', width: '100px'},
];

export const enum UserStatus {
  new = 'נשלחה בקשה',
  TempFailure = 'כישלון זמני',
  PermFailure = 'הזמנה נכשלה',
  Success = 'בוצעה הזמנה',
  ExistingCustomer = 'מנוי מאוקטב',
  EndingWithFailure = 'סיום עם כשלון',
}

export const StatusTextAndColor: {
  [key: string]: {
    status: string;
    text: string;
    color: string;
  };
} = {
  new: {
    status: UserStatus.new,
    text: 'נשלחה בקשה למנוי לביצוע הזמנה',
    color: '#f7ff9b',
  },
  TempFailure: {
    status: UserStatus.TempFailure,
    text: '',
    color: '#ffc8c2',
  },
  PermFailure: {
    status: UserStatus.PermFailure,
    text: '',
    color: '#ffc8c2',
  },

  Success: {
    status: UserStatus.Success,
    text: 'בוצעה הזמנה ע"י המנוי',
    color: '#ceeab7',
  },
  ExistingCustomer: {
    status: UserStatus.ExistingCustomer,
    text: '',
    color: '#f7ff9b',
  },
  EndingWithFailure: {
    status: UserStatus.EndingWithFailure,
    text: '',
    color: '#ffc8c2',
  },
};

export const Error = {
  nameOrPhoneIsNotValid: 'שם או מספר טלפון אינם תקינים',
  noDataFoundBySearch: 'לא נמצאו תוצאות שתואמות את החיפוש ',
};

export const IconList = {
  error: require('./icons/error.svg'),
  success: require('./icons/success.svg'),
  headsPhone: require('./icons/headsPhone.svg'),
};
export enum ButtonColor {
  white = 'white',
  primary = 'primary',
}

const brandNameHe = () => window.Config?.brand_Name_HE;

export const MessageContent: {
  [key: string]: {
    title: string;
    secondTitle: string;
    icon: string;
    buttonText: string;
    buttonClick?: string;
    buttonColor?: string;
    secondButtonText?: string;
    secondButtonClick?: string;
    secondButtonColor?: string;
  };
} = {
  GeneralError: {
    title: 'מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לאחראי השירות',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
  },
  IsCellcomUser: {
    title: 'המנוי פעיל ולא ניתן לערוך את הפרטים',
    secondTitle: 'אפשר לפנות לאחראי/ת השירות להמשך טיפול',
    icon: IconList.success,
    buttonText: 'הבנתי , תודה',
    buttonClick: 'closePopUp',
  },
  ProcessNotCompletedByUser: {
    title: 'הזמנה נכשלה',
    secondTitle: 'המנוי לא השלים את התהליך, ניתן לפנות לאחראי/ת השירות להמשך טיפול',
    icon: IconList.headsPhone,
    buttonText: 'הבנתי , תודה',
    buttonClick: 'closePopUp',
  },
  SapOrderAlreadyCreated: {
    get title() {
      return `ההזמנה הוקמה ב${brandNameHe()} ולא ניתן לערוך את הפרטים`;
    },
    secondTitle: 'אפשר לפנות לאחראי/ת השירות להמשך טיפול',
    icon: IconList.error,
    buttonText: 'הבנתי , תודה',
    buttonClick: 'closePopUp',
  },
  DeleteUserSucceeded: {
    title: 'המנוי נמחק בהצלחה',
    secondTitle: '',
    icon: IconList.success,
    buttonText: 'סיום',
    buttonClick: 'closePopUp',
  },
  DeleteUserConfirmation: {
    title: 'בטוח כי ברצונך למחוק את המנוי?',
    secondTitle: 'לתשומת לבך, מחיקת המנוי לא תאפשר לו להיכנס לקישור שנשלח אליו',
    icon: IconList.error,
    buttonText: 'ביטול',
    buttonClick: 'openUpdateUserPopup',
    buttonColor: ButtonColor.white,
    secondButtonText: 'מחיקת המנוי',
    secondButtonClick: 'deleteOrgUser',
  },
  SendLinkSucceeded: {
    title: 'נשלחה בקשה למנוי!',
    secondTitle: '',
    icon: IconList.success,
    buttonText: 'סיום',
    buttonClick: 'closePopUp',
  },
  SendLinkConfirmation: {
    title: 'האם ברצונך לבצע שליחה חוזרת למנוי?',
    secondTitle: '',
    icon: IconList.error,
    buttonText: 'ביטול',
    buttonClick: 'openUpdateUserPopup',
    buttonColor: ButtonColor.white,
    secondButtonText: 'שליחה חוזרת',
    secondButtonClick: 'sendLinkToUser',
  },
  UpdateUserSucceeded: {
    title: 'המנוי עודכן בהצלחה',
    secondTitle: '',
    icon: IconList.success,
    buttonText: 'סיום',
    buttonClick: 'closePopUp',
  },
  UploadFileError: {
    title: 'אירעה שגיאה בטעינת הקובץ',
    secondTitle: '',
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
    buttonClick: 'closePopUp',
  },
  UploadFileSuccess: {
    title: 'קובץ קליטת עובדים נטען בהצלחה!',
    secondTitle: '',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
  },
  UploadFileSuccessUpgrade: {
    title: 'קובץ שדרוג עובדים נטען בהצלחה!',
    secondTitle: '',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
  },
};

export const getStatusTextAndColor = (status) => {
  const matchingKey = Object.keys(StatusTextAndColor).find((key) => StatusTextAndColor[key].status == status);
  return StatusTextAndColor[matchingKey];
};
